import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import xtend from 'xtend';
import moment from 'moment';

// import deepExtend from 'deep-extend';
import Listing from './EventsListing';
import { isWithinRange } from 'date-fns';
import parse from 'date-fns/parse'
import { getContentGroupData, getHasRequestPending } from '../redux/data/selectors';
import reduxStore from '../redux/store'
import actions from '../redux/actions';
import { GET_ENCODERS } from '../redux/data/types';
import { connect } from 'react-redux'
import QueryString from '../utils/QueryString';
import store from '../redux/store';
import Storage from '../utils/Storage';
import { EVENT_VIEW_TYPES } from '../redux/events/reducers';
// import WorkspaceStore from '../common/flux/stores/WorkspaceStore';


var EventsController = createReactClass({
    propTypes: {
        actions: pt.shape({
            get: pt.func.isRequired,
            filterChange: pt.func.isRequired,
            pageChange: pt.func.isRequired,
            search: pt.func.isRequired,
            toggleActiveEvent: pt.func.isRequired,
            events: pt.object.isRequired,
            encoders: pt.object.isRequired,
            metadata: pt.object.isRequired,
            metamarkers: pt.object.isRequired,
            assets: pt.object.isRequired
            // transcript: pt.object.isRequired
        }).isRequired,
        store: pt.func.isRequired,
        onError: pt.func.isRequired,
        onWorkspaceAction: pt.func.isRequired,
        clientID: pt.string.isRequired
    },

    getInitialState: function () {
        return this.props.store();
    },
    componentDidUpdate: function(prevProps, prevState) {
        if (prevProps.viewType !== this.props.viewType && this.state.requestedEvents) {
            this.requestEvents()
        }

        // Request analytics as soon as the events list lands.
        //
        // Without this the first event in the slim view sits on a spinner
        // for up to 10 seconds. The sequence: componentDidMount fires
        // requestEvents() (async) and then requestEventAnalytics()
        // immediately -- but that bails unless BOTH the events list and
        // `events.expanded` are populated, and at mount neither is. The
        // list then resolves and the reducer auto-expands the first event
        // (`setFirstEventExpanded`), so an event renders in its expanded,
        // analytics-dependent state having never had analytics requested.
        // Nothing retries until the 10s interval comes round, which is why
        // expanding any other event -- which dispatches for the whole
        // expanded set, first event included -- appears to "fix" it.
        //
        // The list is cleared when a fetch starts, so empty -> populated
        // reliably marks arrival, including after a view switch or a
        // filter change.
        const hadEvents = Object.keys(prevProps.events || {}).length > 0
        const hasEvents = Object.keys(this.props.events || {}).length > 0
        if (!hadEvents && hasEvents) {
            this.requestEventAnalytics()
        }
    },

    componentDidMount: function () {
        var self = this;
        this.props.onError(function (err) {
            self.props.emitSnack({
                type: 'error',
                message: err.message[0]
            });
        });         

        this.removeListener = this.props.store(function onChange (data) {
            if (data && data.message && data.message.message && data.message.message.error && data.message.message.error.message) {
                data.error = {error:data.message.message.error}
            }
            self.setState(data);
        });

        this.requestEvents()

        // request analytics for events in these views
        const analyticsViews = [EVENT_VIEW_TYPES.SLIM.key]
        if (analyticsViews.indexOf(this.props.viewType) > -1) {
            this.requestEventAnalytics()
            this.analyticsInterval = setInterval(this.requestEventAnalytics, 10000)
        }
    },

    componentWillUnmount: function () {
        this.removeListener();
        clearInterval(this.analyticsInterval)
    },

    requestEventAnalytics: async function() {
        const expandedEvents = reduxStore.getState().events.expanded
        if (Object.keys(this.props.events).length && expandedEvents.length) {
            reduxStore.dispatch(actions.data.requestEventAnalytics(expandedEvents))
        }
    },

    requestEvents: function() {
        this.setState({requestedEvents: true})
        const filters = QueryString.parse(window.location.search)
        let resultMax = Storage.get('VIEW_RESULT_MAX')
        filters.resultMax = (resultMax && resultMax[store.getState().events.viewType.key]) || Math.min(filters.resultMax, 100) // max 100 events in initial request
        this.props.fetchEvents(filters, true)
    },

    // pass strings, not moment objects
    handleFilterChange: function (ev) {
        if (ev.type === 'change') {
            var params = xtend(ev.params);
            if (params.startDateTime) {
                params.startDateTime = params.startDateTime.startOf('day');
            }
            if (params.stopDateTime) {
                params.stopDateTime = params.stopDateTime.endOf('day');
            }
            if (!params.liveOnly) {
                params.liveOnly = false
            }
            if (!params.getOnlyPrivate) {
                params.getOnlyPrivate = false
            }
            const filters = {...this.props.filters, ...params}
            if (!params.eventID) {
                // eventID must come from the request
                delete filters.eventID
            }
            if (!this.state.requestedEvents || this.props.viewType.key !== EVENT_VIEW_TYPES.CALENDAR.key) {
                this.setState({requestedEvents: true})
                this.props.fetchEvents(filters)
            }
        } else if (ev.type === 'reset') {
            this.setState({requestedEvents: true})
            this.props.setFilters(null)
            this.props.fetchEvents(null)
        }
    },

    getFilters: function () {
        var filters = this.props.filters;
        filters = xtend(filters, {
            startDateTime: moment(filters.startDateTime),
            stopDateTime: moment(filters.stopDateTime)
        });
        filters.getOnlyPrivate = filters.getOnlyPrivate === 'true' || filters.getOnlyPrivate === true
        return filters
    },

    handlePaginationChange: function (page) {
        // this.props.actions.pageChange(page);
        this.props.pageChange(page)
    },

    handleSearch: function (query) {
        // if no categories are in query add this users group categories 
        if (!(query.anyCategories && query.anyCategories.length !== 0)) {
            const { contentGroups, categories } = getContentGroupData(reduxStore.getState())
            if (contentGroups.length) {
                query.anyCategories = categories.map(category => category.categoryID)
            }
        }
        this.props.actions.search(query);
    },
    filterEvents: function (events, filters) {
        const { contentGroups, categories } = getContentGroupData(reduxStore.getState())
        let eventIdsToRemove = []
        if (contentGroups.length && events.length) {
            // check that any event content group is assigned to the user if there are any assigned to the event
            Object.keys(events).forEach(eventID => {
                const event = events[eventID]
                const hasMatchingCategory = event.categories.some(eventCategoryName => {
                    return categories.some(groupCategory => groupCategory.categoryName === eventCategoryName)
                })
                // if there was no matched content group containing the events category hide the event
                if (!hasMatchingCategory) {
                    eventIdsToRemove.push(eventID)
                }
            })
        }
        // search filters for eventID and customID don't have date filters so return early
        if (filters.eventID || filters.customID) {
            var key = filters.eventID ? 'eventID' : 'customID'
            Object.keys(events).forEach(eventID => {
                if (eventID !== filters.eventID && events[eventID].customID !== filters.customID) {
                    eventIdsToRemove.push(eventID)
                }
            })
            eventIdsToRemove.forEach(eventID => {
                delete events[eventID]
            })
            return events
        }

        // show no events if bad start/end date filters
        if (filters.startDateTime > filters.stopDateTime) {
            eventIdsToRemove = Object.keys(events)
        }

        // show events with start date within start and end date filters
        Object.keys(events).forEach(eventID => {
            const event = events[eventID]
            if (!isWithinRange(parse(event.startDateTime), moment(filters.startDateTime), moment(filters.stopDateTime).endOf('day'))) {
                eventIdsToRemove.push(eventID)
            }
        })

        // show only private events with that filter
        if (filters.getOnlyPrivate) {
            Object.keys(events).forEach(eventID => {
                const event = events[eventID]
                if (!event.private) {
                    eventIdsToRemove.push(eventID)
                }
            })
        }

        // show only live events with that filter
        if (filters.liveOnly) {
            Object.keys(events).forEach(eventID => {
                const event = events[eventID]
                // if the event status is not "live" or "on break" hide it
                if (event.eventStatus !== 'live' && event.eventStatus !== 'on break') {
                    eventIdsToRemove.push(eventID)
                }
            })
        }

        // if filtering by description or title verify they match
        if (filters.title || filters.description) {
            var key = filters.title ? 'title' : 'description'
            Object.keys(events).forEach(eventID => {
                const event = events[eventID]
                if (event[key] && event[key].toLowerCase().indexOf(filters[key].toLowerCase()) === -1) {
                    eventIdsToRemove.push(eventID)
                }
            })
        }

        // if filtering by keyword or category verify they match
        if (filters.keywords || filters.category) {
            if (filters.keywords) {
                Object.keys(events).forEach(eventID => {
                    const event = events[eventID]
                    if (event.keywords && !event.keywords.includes(filters.keywords)) {
                        eventIdsToRemove.push(eventID)
                    }
                })
            } else {
                Object.keys(events).forEach(eventID => {
                    const event = events[eventID]
                    if (event.categories && !event.categories.includes(filters.category)) {
                        eventIdsToRemove.push(eventID)
                    }
                })
            }
        }
        Object.keys(events).forEach(eventID => {
            if (eventIdsToRemove.includes(eventID)) {
                delete events[eventID]
            }
        })
        return events
    },
    render: function () {
        return <Listing
            ga={this.props.ga}
            timeZone={this.props.credentials.client.timeZone}
            facebookAppID={this.props.facebookAppID}
            clientID={this.props.clientID}
            emitSnack={this.props.emitSnack}
            events={this.filterEvents(this.props.events, this.props.filters)}
            eventsLoaded={this.state.requestedEvents && !this.props.eventsRequestPending}
            // events={this.filterEvents(this.props.events, this.getFilters())}
            eventAnalytics={this.state.data.eventAnalytics}
            eventAjaxState={this.state.data.eventAjaxState}
            // encoders={this.state.data.encoders}
            encoders={this.props.encoders}
            metadata={this.state.data.metadata}

            transcript={this.state.data.transcript}
            transcriptView={this.state.data.transcriptView}

            streamTargets={this.state.data.streamTargets}
            streamTargetView={this.state.data.streamTargetView}
            eventTargetDestinations={this.state.data.eventTargetDestinations}

            miscAssets={this.state.data.miscAssets}
            facebookLiveEvents={this.state.data.facebookLiveEvents}
            preferences={this.state.data.preferences}
            activeEvent={this.state.activeEvent}
            onActivateEvent={this.props.actions.toggleActiveEvent}
            encoderActions={this.props.actions.encoders}
            actions={this.props.actions}
            onFilterChange={this.handleFilterChange}
            onSearch={this.handleSearch}
            filters={this.getFilters()}
            search={this.state.search}
            query={this.state.query}
            onWorkspaceAction={this.props.onWorkspaceAction}
            error={this.state.error}
            message={this.state.message}

            chat={this.state.data.chat}

            socket={this.state.socket}
            requests={this.state.requests}
            pagination={xtend(this.state.pagination, {
                onPageChange: this.handlePaginationChange
            })}
            getUppy={this.props.getUppy}
        />;
    }
});

const mergeProps = (stateProps, _dispatchProps, ownProps) => {
    const dispatch = func => _dispatchProps.callDispatch(func)
    const setFilters = filters => {
        dispatch(actions.events.setEventsFilter(filters, true))
    }
    const fetchEvents = (filters) => {
        if (filters) {
            dispatch(actions.events.setEventsFilter(filters, true))
        }
        dispatch(actions.data.requestEvents())
    }

    const pageChange = page => dispatch(actions.events.pageChange(page))
    return { setFilters, fetchEvents, pageChange, ...stateProps, ...ownProps }
}

const mapDispatchToProps = dispatch => ({
  callDispatch: func => dispatch(func),
})

const mapStateToProps = state => {
    const events = state.data.events
    const filters = state.events.filters
    const eventsRequestPending = getHasRequestPending(state, 'BUS/http.events.get')
    const viewType = state.events.viewType.key
    const encoders = { data: state.data.encoders, isResolving: getHasRequestPending(state, GET_ENCODERS)}
    return { events, filters, eventsRequestPending, viewType, encoders }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventsController)
